/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { AssociaFattureProgettoDtoListFromJSON, AssociaFattureProgettoDtoListToJSON, CicloPassivoFieldsDtoFromJSON, CompetenzaFattureOutpuDtoFromJSON, CompetenzaFattureOutpuDtoToJSON, CompetenzeMeseAnnoFattureOutputDtoFromJSON, ContractOrderOutputDtoFromJSON, ContractOrderOutputListDtoFromJSON, ContractOrderSearchDtoToJSON, CreateContractOrderAttivoDtoToJSON, ExternalCostRowDtoToJSON, FatturaEmessaPagedDtoFromJSON, FatturaEmessaSearchDtoToJSON, FatturaRicevutaPagedDtoFromJSON, FatturaRicevutaSearchDtoToJSON, ProjectLightInfoDtoFromJSON, } from '../models/index';
/**
 *
 */
export class FattureProgettoControllerApi extends runtime.BaseAPI {
    /**
     * Consente di creare o aggiornare una lista di associazioni di fatture a progetti
     * Associa una lista di fatture ad un progetto
     */
    associaFatturaProgettoRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['associaFattureProgettoDtoList'] == null) {
                throw new runtime.RequiredError('associaFattureProgettoDtoList', 'Required parameter "associaFattureProgettoDtoList" was null or undefined when calling associaFatturaProgetto().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/fatture/associa-fattura-progetto`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: AssociaFattureProgettoDtoListToJSON(requestParameters['associaFattureProgettoDtoList']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => AssociaFattureProgettoDtoListFromJSON(jsonValue));
        });
    }
    /**
     * Consente di creare o aggiornare una lista di associazioni di fatture a progetti
     * Associa una lista di fatture ad un progetto
     */
    associaFatturaProgetto(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.associaFatturaProgettoRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Consente di creare o aggiornare una lista di associazioni di fatture a progetti ad utenti esterni
     * Associa una lista di fatture ad un progetto ed un utente esterno
     */
    associaFatturaProgettoUtenteEsternoRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['competenzaFattureOutpuDto'] == null) {
                throw new runtime.RequiredError('competenzaFattureOutpuDto', 'Required parameter "competenzaFattureOutpuDto" was null or undefined when calling associaFatturaProgettoUtenteEsterno().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/fatture/associa-fattura-utente-esterno`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters['competenzaFattureOutpuDto'].map(CompetenzaFattureOutpuDtoToJSON),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CompetenzaFattureOutpuDtoFromJSON));
        });
    }
    /**
     * Consente di creare o aggiornare una lista di associazioni di fatture a progetti ad utenti esterni
     * Associa una lista di fatture ad un progetto ed un utente esterno
     */
    associaFatturaProgettoUtenteEsterno(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.associaFatturaProgettoUtenteEsternoRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Crea un nuovo ordine
     */
    createCicloAttivoRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['createContractOrderAttivoDto'] == null) {
                throw new runtime.RequiredError('createContractOrderAttivoDto', 'Required parameter "createContractOrderAttivoDto" was null or undefined when calling createCicloAttivo().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/fatture/create-ciclo-attivo`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: CreateContractOrderAttivoDtoToJSON(requestParameters['createContractOrderAttivoDto']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ContractOrderOutputDtoFromJSON(jsonValue));
        });
    }
    /**
     * Crea un nuovo ordine
     */
    createCicloAttivo(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createCicloAttivoRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Consente di eliminare una fattura progetto tramite il suo ID
     * Elimina una fattura progetto
     */
    deleteFatturaCicloPassivoRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling deleteFatturaCicloPassivo().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/fatture/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Consente di eliminare una fattura progetto tramite il suo ID
     * Elimina una fattura progetto
     */
    deleteFatturaCicloPassivo(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteFatturaCicloPassivoRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Consente di eliminare una fattura progetto tramite il suo ID
     * Elimina una fattura competenza mese anno
     */
    deleteFatturaCompetenzaMeseAnnoAttivoRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['idProject'] == null) {
                throw new runtime.RequiredError('idProject', 'Required parameter "idProject" was null or undefined when calling deleteFatturaCompetenzaMeseAnnoAttivo().');
            }
            if (requestParameters['fkRowFattura'] == null) {
                throw new runtime.RequiredError('fkRowFattura', 'Required parameter "fkRowFattura" was null or undefined when calling deleteFatturaCompetenzaMeseAnnoAttivo().');
            }
            if (requestParameters['idOrdine'] == null) {
                throw new runtime.RequiredError('idOrdine', 'Required parameter "idOrdine" was null or undefined when calling deleteFatturaCompetenzaMeseAnnoAttivo().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/fatture/competenza_meseanno_fattura_attivo_delete/{idProject}/{fkRowFattura}/{idOrdine}`.replace(`{${"idProject"}}`, encodeURIComponent(String(requestParameters['idProject']))).replace(`{${"fkRowFattura"}}`, encodeURIComponent(String(requestParameters['fkRowFattura']))).replace(`{${"idOrdine"}}`, encodeURIComponent(String(requestParameters['idOrdine']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Consente di eliminare una fattura progetto tramite il suo ID
     * Elimina una fattura competenza mese anno
     */
    deleteFatturaCompetenzaMeseAnnoAttivo(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteFatturaCompetenzaMeseAnnoAttivoRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Consente di eliminare una fattura progetto tramite il suo ID
     * Elimina una fattura progetto
     */
    deleteFatturaProgettoRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['pkFatture'] == null) {
                throw new runtime.RequiredError('pkFatture', 'Required parameter "pkFatture" was null or undefined when calling deleteFatturaProgetto().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/fatture/pkFatture/{pkFatture}`.replace(`{${"pkFatture"}}`, encodeURIComponent(String(requestParameters['pkFatture']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Consente di eliminare una fattura progetto tramite il suo ID
     * Elimina una fattura progetto
     */
    deleteFatturaProgetto(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteFatturaProgettoRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Recupera tutti i possibili valori che le fatture possono assumere
     * Possibili valori nelle select del ciclo passivo
     */
    getFattureFieldsRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/fatture/fields`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CicloPassivoFieldsDtoFromJSON(jsonValue));
        });
    }
    /**
     * Recupera tutti i possibili valori che le fatture possono assumere
     * Possibili valori nelle select del ciclo passivo
     */
    getFattureFields(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getFattureFieldsRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    getListFattureAssociateUtenteEsternoRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['idOrdine'] == null) {
                throw new runtime.RequiredError('idOrdine', 'Required parameter "idOrdine" was null or undefined when calling getListFattureAssociateUtenteEsterno().');
            }
            if (requestParameters['fkRowFattura'] == null) {
                throw new runtime.RequiredError('fkRowFattura', 'Required parameter "fkRowFattura" was null or undefined when calling getListFattureAssociateUtenteEsterno().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/fatture/fatture-utente-esterno/{idOrdine}/{fkRowFattura}`.replace(`{${"idOrdine"}}`, encodeURIComponent(String(requestParameters['idOrdine']))).replace(`{${"fkRowFattura"}}`, encodeURIComponent(String(requestParameters['fkRowFattura']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CompetenzaFattureOutpuDtoFromJSON));
        });
    }
    /**
     */
    getListFattureAssociateUtenteEsterno(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getListFattureAssociateUtenteEsternoRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Restituisce una lista di informazioni sui progetti da associare a fatture attive
     * OOttiene informazioni per select sui progetti da associare a fatture attive
     */
    getProjectLightInfoFattureAttiveRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/fatture/progetti-fatture-attive`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProjectLightInfoDtoFromJSON));
        });
    }
    /**
     * Restituisce una lista di informazioni sui progetti da associare a fatture attive
     * OOttiene informazioni per select sui progetti da associare a fatture attive
     */
    getProjectLightInfoFattureAttive(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getProjectLightInfoFattureAttiveRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Restituisce una lista di informazioni sui progetti da associare a fatture passive
     * Ottiene informazioni per select sui progetti da associare a fatture passive
     */
    getProjectLightInfoFatturePassiveRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/fatture/progetti-fatture-passive`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProjectLightInfoDtoFromJSON));
        });
    }
    /**
     * Restituisce una lista di informazioni sui progetti da associare a fatture passive
     * Ottiene informazioni per select sui progetti da associare a fatture passive
     */
    getProjectLightInfoFatturePassive(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getProjectLightInfoFatturePassiveRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Consente di ottenere tutte le fatture ciclo attivo competenze
     * Ricerca competenze mese anno fature ciclo attivo
     */
    searchCompetenzeFattureCicloAttivoRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['idProject'] == null) {
                throw new runtime.RequiredError('idProject', 'Required parameter "idProject" was null or undefined when calling searchCompetenzeFattureCicloAttivo().');
            }
            if (requestParameters['fkRowFattura'] == null) {
                throw new runtime.RequiredError('fkRowFattura', 'Required parameter "fkRowFattura" was null or undefined when calling searchCompetenzeFattureCicloAttivo().');
            }
            if (requestParameters['idOrdine'] == null) {
                throw new runtime.RequiredError('idOrdine', 'Required parameter "idOrdine" was null or undefined when calling searchCompetenzeFattureCicloAttivo().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/fatture/competenze_meseanno_fattura_attivo/search/{idProject}/{fkRowFattura}/{idOrdine}`.replace(`{${"idProject"}}`, encodeURIComponent(String(requestParameters['idProject']))).replace(`{${"fkRowFattura"}}`, encodeURIComponent(String(requestParameters['fkRowFattura']))).replace(`{${"idOrdine"}}`, encodeURIComponent(String(requestParameters['idOrdine']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CompetenzaFattureOutpuDtoFromJSON(jsonValue));
        });
    }
    /**
     * Consente di ottenere tutte le fatture ciclo attivo competenze
     * Ricerca competenze mese anno fature ciclo attivo
     */
    searchCompetenzeFattureCicloAttivo(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.searchCompetenzeFattureCicloAttivoRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Consente di ottenere tutte le fatture ricevute utilizzando filtri dinamici
     * Ricerca competenze mese anno
     */
    searchCompetenzeUtenteEsternoRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['idOrdine'] == null) {
                throw new runtime.RequiredError('idOrdine', 'Required parameter "idOrdine" was null or undefined when calling searchCompetenzeUtenteEsterno().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/fatture/competenza_meseanno/search/{idOrdine}`.replace(`{${"idOrdine"}}`, encodeURIComponent(String(requestParameters['idOrdine']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CompetenzaFattureOutpuDtoFromJSON));
        });
    }
    /**
     * Consente di ottenere tutte le fatture ricevute utilizzando filtri dinamici
     * Ricerca competenze mese anno
     */
    searchCompetenzeUtenteEsterno(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.searchCompetenzeUtenteEsternoRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Consente di ottenere tutte le fatture ricevute utilizzando filtri dinamici
     * Ricerca competenze mese anno
     */
    searchCompetenzefattureMeseAnnoRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['idOrdine'] == null) {
                throw new runtime.RequiredError('idOrdine', 'Required parameter "idOrdine" was null or undefined when calling searchCompetenzefattureMeseAnno().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/fatture/competenza_meseanno_fattura_attivo/search/{idOrdine}`.replace(`{${"idOrdine"}}`, encodeURIComponent(String(requestParameters['idOrdine']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CompetenzeMeseAnnoFattureOutputDtoFromJSON));
        });
    }
    /**
     * Consente di ottenere tutte le fatture ricevute utilizzando filtri dinamici
     * Ricerca competenze mese anno
     */
    searchCompetenzefattureMeseAnno(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.searchCompetenzefattureMeseAnnoRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Ricerca contratti
     */
    searchContractOrdersRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['contractOrderSearchDto'] == null) {
                throw new runtime.RequiredError('contractOrderSearchDto', 'Required parameter "contractOrderSearchDto" was null or undefined when calling searchContractOrders().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/fatture/search-orders-attivi`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ContractOrderSearchDtoToJSON(requestParameters['contractOrderSearchDto']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ContractOrderOutputListDtoFromJSON(jsonValue));
        });
    }
    /**
     * Ricerca contratti
     */
    searchContractOrders(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.searchContractOrdersRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Consente di ottenere tutte le fatture emesse utilizzando filtri dinamici
     * Ricerca fatture emesse con filtri
     */
    searchFattureEmesseRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['fatturaEmessaSearchDto'] == null) {
                throw new runtime.RequiredError('fatturaEmessaSearchDto', 'Required parameter "fatturaEmessaSearchDto" was null or undefined when calling searchFattureEmesse().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/fatture/emesse/search`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: FatturaEmessaSearchDtoToJSON(requestParameters['fatturaEmessaSearchDto']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => FatturaEmessaPagedDtoFromJSON(jsonValue));
        });
    }
    /**
     * Consente di ottenere tutte le fatture emesse utilizzando filtri dinamici
     * Ricerca fatture emesse con filtri
     */
    searchFattureEmesse(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.searchFattureEmesseRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Consente di ottenere tutte le fatture ricevute utilizzando filtri dinamici
     * Ricerca fatture ricevute con filtri
     */
    searchFattureRicevuteRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['fatturaRicevutaSearchDto'] == null) {
                throw new runtime.RequiredError('fatturaRicevutaSearchDto', 'Required parameter "fatturaRicevutaSearchDto" was null or undefined when calling searchFattureRicevute().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/fatture/ricevute/search`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: FatturaRicevutaSearchDtoToJSON(requestParameters['fatturaRicevutaSearchDto']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => FatturaRicevutaPagedDtoFromJSON(jsonValue));
        });
    }
    /**
     * Consente di ottenere tutte le fatture ricevute utilizzando filtri dinamici
     * Ricerca fatture ricevute con filtri
     */
    searchFattureRicevute(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.searchFattureRicevuteRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Consente di ottenere tutte le fatture ricevute utilizzando filtri dinamici
     * Ricerca fatture ricevute con filtri
     */
    searchFattureRicevuteByProjectRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['externalCostRowDto'] == null) {
                throw new runtime.RequiredError('externalCostRowDto', 'Required parameter "externalCostRowDto" was null or undefined when calling searchFattureRicevuteByProject().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/fatture/ricevute_project/search`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ExternalCostRowDtoToJSON(requestParameters['externalCostRowDto']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => FatturaRicevutaPagedDtoFromJSON(jsonValue));
        });
    }
    /**
     * Consente di ottenere tutte le fatture ricevute utilizzando filtri dinamici
     * Ricerca fatture ricevute con filtri
     */
    searchFattureRicevuteByProject(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.searchFattureRicevuteByProjectRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Consente di ottenere tutte le fatture ricevute utilizzando filtri dinamici
     * Ricerca fatture ricevute con filtri
     */
    searchFattureUtenteEsternoRicevuteRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['idOrdine'] == null) {
                throw new runtime.RequiredError('idOrdine', 'Required parameter "idOrdine" was null or undefined when calling searchFattureUtenteEsternoRicevute().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/fatture/fatture-utente-esterno/search/{idOrdine}`.replace(`{${"idOrdine"}}`, encodeURIComponent(String(requestParameters['idOrdine']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => FatturaRicevutaPagedDtoFromJSON(jsonValue));
        });
    }
    /**
     * Consente di ottenere tutte le fatture ricevute utilizzando filtri dinamici
     * Ricerca fatture ricevute con filtri
     */
    searchFattureUtenteEsternoRicevute(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.searchFattureUtenteEsternoRicevuteRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
